export type Membership = {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    oib: string;
    dateOfBirth: Date;
    startsAt: Date;
    endsAt?: Date;
    membershipType: MembershipType;
    approvedAt?: Date;
};

export const MembershipType = {
    Supporting: 'Supporting',
    Regular: 'Regular',
    Honorary: 'Honorary',
} as const;
export type MembershipType = typeof MembershipType[keyof typeof MembershipType];

export type CreateMembership = {
    userId: string;
    firstName: string;
    lastName: string;
    oib: string;
    dateOfBirth: Date;
};

export type UpdateMembershipStart = {
    userId: string;
    startsAt: Date;
};

export type EndMembership = {
    userId: string;
    endsAt: Date;
};

export type UpdateMembershipType = {
    membershipType: MembershipType;
};

export type ApproveMembership = {
    userId: string;
};

export type FullMembership = Membership & {
    email: string;
    username: string;
    discordUsername?: string;
    hoursVolunteered: number;
    gamesWithoutRecord: GameWithoutRecord[];
};

export type GameWithoutRecord = {
    date: Date;
    gameId: string;
    title: string;
};

